import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash-es/get';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, Heading, Button } from '@components/common';
import { MobileContainer } from '@containers/layout';
import AddonSingleSelector from './AddonSingleSelector';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import { AppSelectors } from '@redux/AppRedux';
import { SERVICE_TYPES, ADDONS } from '@services/minte';
import { stripePriceConverter } from '@services/transform';

const MobileFlexWrapper = styled(Box)`
  @media screen and (max-width: 767px) {
    flex: 1;
  }
`;

function AddonSingle(props) {
  const {
    serviceType,
    selectedAddons,
    addonData,
    selectAddon,
    deselectAddon,
    propertyInfo,
    onSubmit
  } = props;

  let totalAddons = Object.keys(addonData);

  if (serviceType === SERVICE_TYPES.DEEP_CLEAN) {
    totalAddons = totalAddons.filter(item => item !== ADDONS.MOPPING);
  }

  return (
    <MobileContainer pt={[0, 0]}>
      <MobileFlexWrapper
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Heading px={2} mb={4}>
          What else can we take off your hands?
        </Heading>
        <Box mb={2} px={2} display="flex" flexDirection="column" width={1}>
          {totalAddons.map(addon => {
            const data = addonData[addon];
            const isSelected = selectedAddons.includes(addon);
            const { title, icon } = data;
            const price = get(propertyInfo, `addons.${addon}`, 0);
            return (
              <AddonSingleSelector
                key={addon}
                selected={isSelected}
                title={title}
                subtitle={`$${stripePriceConverter(price)}`}
                icon={icon}
                onClick={() => {
                  if (isSelected) {
                    deselectAddon(addon);
                  } else {
                    selectAddon(addon);
                  }
                }}
                mb={4}
              />
            );
          })}
        </Box>
      </MobileFlexWrapper>

      <Button
        width={1}
        mt={4}
        mb={4}
        type="button"
        onClick={() => {
          onSubmit();
        }}
      >
        Continue
      </Button>
    </MobileContainer>
  );
}

AddonSingle.propTypes = {
  serviceType: PropTypes.string,
  selectedAddons: PropTypes.array,
  addonData: PropTypes.object,
  selectAddon: PropTypes.func,
  deselectAddon: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  propertyInfo: PropTypes.object
};

const mapStatesToProps = state => ({
  serviceType: BookingSelectors.selectServiceType(state),
  selectedAddons: BookingSelectors.selectAddons(state),
  addonData: AppSelectors.selectAddonData(state),
  propertyInfo: AppSelectors.selectPropertyInfoOf(
    state,
    BookingSelectors.selectCurrentProperty(state)
  )
});

const mapDispatchToProps = dispatch => ({
  selectAddon: addon => dispatch(BookingActions.addBookingAddon(addon)),
  deselectAddon: addon => dispatch(BookingActions.removeBookingAddon(addon))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AddonSingle);
